import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { MenuService } from '../menu/menu.service';

@Injectable({
  providedIn: 'root'
})
export class NavMenuService {
  linkHover: any;
  linkHover2: any;
  linkHover3: any;
  secondLevelBoolean = false;

  private sidenav: MatSidenav;

  constructor(private menuService: MenuService) { }

  setSidenav(sidenav: MatSidenav): void {
    this.sidenav = sidenav;
  }

  closeSidenav(): void {
    this.sidenav?.close();
  }

  hoverL1(link: any): void {
    this.linkHover = link;
    this.menuService.setCurrentMenu(link.text);
    if (this.linkHover?.menu?.length > 0) {
      this.secondLevelBoolean = true;
      if (!this.linkHover.menu[0]?.menu) {
        this.sidenav?.close();
      }
    } else {
      this.secondLevelBoolean = false;
      this.sidenav?.close();
    }
  }

  hoverL2(link: any): void {
    this.linkHover2 = link;
    if (this.linkHover2?.menu?.length > 0) {
      this.sidenav?.open();
    } else {
      this.sidenav?.close();
    }
  }

  hoverL3(link: any): void {
    this.linkHover3 = link;
  }
}
